import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { TableHeaderInterfaceModel } from '../../../models/table.model';

@Component({
  selector: 'app-table-header-navigation',
  templateUrl: './table-header-navigation.component.html',
  styleUrl: './table-header-navigation.component.scss',
  standalone: false,
})
export class TableHeaderNavigationComponent {
  @Input() slides: TableHeaderInterfaceModel[] = [];
  @Input() isLoading = false;
  @Output() cardClicked = new EventEmitter<TableHeaderInterfaceModel>();

  currentIndex: number = 0;

  @ViewChild('scrl') scrl: ElementRef | undefined;

  scrollX = 0;
  scrollEnd = false;

  goToPrevious(): void {
    const isFirstSlide = this.currentIndex === 0;
    const newIndex = isFirstSlide
      ? this.slides.length - 1
      : this.currentIndex - 1;

    this.currentIndex = newIndex;
  }

  goToNext(): void {
    const isLastSlide = this.currentIndex === this.slides.length - 1;
    const newIndex = isLastSlide ? 0 : this.currentIndex + 1;

    this.currentIndex = newIndex;
  }

  goToSlide(slideIndex: number): void {
    this.currentIndex = slideIndex;
  }

  getCurrentSlideTitle() {
    return this.slides[this.currentIndex].title;
  }
  getCurrentSlideDetails() {
    return this.slides[this.currentIndex].details;
  }

  slide(shift: number) {
    if (this.scrl) {
      this.scrl.nativeElement.scrollBy({
        left: shift,
        behavior: 'smooth',
      });
      if (this.scrollX <= 4 && shift === -300) {
        shift += this.scrl.nativeElement.scrollWidth;
      } else if (this.scrollEnd && shift === 300) {
        shift -= this.scrl.nativeElement.scrollWidth;
      }
      this.scrl.nativeElement.scrollLeft += shift;
      this.scrollX += shift;

      this.scrollCheck();
    }
  }

  scrollCheck() {
    if (this.scrl) {
      this.scrollX = this.scrl.nativeElement.scrollLeft;
      this.scrollEnd =
        Math.floor(
          this.scrl.nativeElement.scrollWidth -
            this.scrl.nativeElement.scrollLeft
        ) <=
        this.scrl.nativeElement.offsetWidth + 4;
    }
  }

  onCardClick(slide: TableHeaderInterfaceModel) {
    this.cardClicked.emit(slide);
  }
}
